// assets
import { DashboardOutlined, AimOutlined } from "@ant-design/icons";
import Permissions from "constants/Permissions";

// ==============================|| MENU ITEMS - DRONES ||============================== //

const drones = {
    id: "group-drones",
    title: "UAV",
    type: "group",
    appModule: "UAV",
    children: [
        {
            id: "drones",
            title: "Drones",
            authority: Permissions.DashboardSection.Dashboard,
            type: "item",
            url: "/drones",
            icon: DashboardOutlined,
            breadcrumbs: false,
        },
        {
            id: "missions",
            title: "Missions",
            authority: Permissions.MissionSection.Mission,
            type: "item",
            url: "/mission",
            icon: AimOutlined,
        },
    ],
};

export default drones;
